(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/prescript.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.baseUrl = '/tipset';


  svs.tipset = svs.tipset || {};

  svs.tipset.views = svs.tipset.views || {};

  svs.tipset.models = svs.tipset.models || {};

  svs.tipset.collections = svs.tipset.collections || {};

  svs.tipset.controllers = svs.tipset.controllers || {};

  svs.tipset.templates = svs.tipset.templates || {};

  svs.tipset.freeReduction = svs.tipset.freeReduction || {};

  svs.tipset.singleRows = svs.tipset.singleRows || {};
  svs.tipset.singleRows.views = svs.tipset.singleRows.views || {};
  svs.tipset.singleRows.models = svs.tipset.singleRows.models || {};
  svs.tipset.singleRows.collections = svs.tipset.singleRows.collections || {};

  svs.tipset.data = svs.tipset.data || {};
  svs.tipset.data.gameDefinitions = svs.tipset.data.gameDefinitions || {};

  var App = Marionette.Application.extend({
    region: '#betslip-wrapper',

    onStart: function() {
      svs.tipset.router = new svs.tipset.Router();
      Backbone.history.start({ pushState: true, root: svs.core.data.baseUrl });
    }
  });

  svs.tipset.app = new App();

  svs.obj = svs.obj || {};

  svs.obj.views = svs.obj.views || {};

  svs.obj.models = svs.obj.models || {};

  svs.obj.collections = svs.obj.collections || {};

  svs.tipset.constants = {
    PRODUCTNAME: {
      STRYKTIPSET: 'Stryktipset',
      EUROPATIPSET: 'Europatipset',
      EMTIPSET: 'EM-Tipset',
      TOPPTIPSET: 'Topptipset',
      POWERPLAY: 'Powerplay'
    },
    IS_U_ROW: 'UROW',
    IS_SPORT_JOKER: 'SPORTJOKER',
    NUMBER_OF_SINGLEROWS: 12,
    DRAW_STATE_OPEN: 2,

    SYSTEM_TYPE: {
      U_SYSTEM: 'U',
      R_SYSTEM: 'R',
      U_ROW: 'UROW'
    },

    ITS_SYSTEM: {
      SYSTEM_TYPES: [
        { systemType: 'U', itsSystemType: 'USYS' },
        { systemType: 'R', itsSystemType: 'RSYS' },
        { systemType: 'SM', itsSystemType: 'MSYS' }
      ],
      MSYS: 'MSYS',
      NO_SYSTEM: 'SROW'
    },
    M_SYSTEM: {
      M_64: 64
    },
    QP_BASEROW: 'PARTIALQP',
    QP_NO_BASEROW: 'WEIGHTEDQP',
    NO_QP: undefined,
    QP_MODIFIED: 'MODIFIEDQP',
    BET_PROPERTIES_COMPETITION: 'COMPETITION',
    BET_PROPERTIES_OWNROWS: 'EGNARADER',
    BET_PROPERTIES_FREE_REDUCE: 'REDUCERA_FRITT',
    BET_PROPERTIES_MARKETPLACE: 'GROUP',
    BET_PROPERTIES_MARKETPLACE_RETAIL: 'GROUP_B2C',
    MG_VALUE: 8,
    MAX_BOARDS_IN_DRAW: 2000,
    MAX_STAKE_IN_DRAW_SYNDICATE: 6000,

    MIN_ROWS_INPUT_REDUCE_FREE: 20,
    MAX_ROWS_INPUT_REDUCE_FREE: 2200,

    NO_OPEN_DRAW_END_MESSAGE_DEFAULT: 'Återkom om en kort stund.',
    PRODUCT_ID: {
      STRYKTIPSET: 1
    }
  };

  (function() {
    svs.tipset.uid = 0;
    svs.tipset.calls = {};
    svs.tipset.calls.store = {};
    svs.tipset.calls.log = new svs.core.log.Logger('svs.tipset.calls');

    svs.tipset.calls.addCall = function(name) {
      svs.tipset.calls.log.debug('RENDER : ' + name);
      var call = svs.tipset.calls.store[name];

      if (!call) {
        call = { name: name, count: 0 };
        svs.tipset.calls.store[name] = call;
      }

      call.count++;
    };
    svs.tipset.getUid = function() {
      svs.tipset.uid++;
      return svs.tipset.uid;
    };
  })();
})(Backbone, _, svs);

 })(window);